import {Country, RegionType} from "@pg-rp/common-types";

export type ISelectedRegionParam = {
    id: number;
    type: RegionType;
    country?: Country | null;
    parent?: null | number | string | {id?: number | string};
};

export const getRegionParentId = (region: ISelectedRegionParam) => {
    if (typeof region.parent === "object" && region.parent?.id) {
        return region.parent.id;
    }

    return region.parent;
};
